import APP_ROUTES from "src/routes/routes";
export const PAGINATION_DEFAULT = {
  page: 1,
  pageSize: 50,
  smallPageSize: 10,
};

export const PROCESS_STATUS = {
  SUBMITTED: "SUBMITTED",
  PENDING: "PENDING",
  RUNNABLE: "RUNNABLE",
  STARTING: "STARTING",
  RUNNING: "RUNNING",
  SUCCEEDED: "SUCCEEDED",
  FAILED: "FAILED",
  SUCCESSFUL: "SUCCESSFUL",
  IN_PROGRESS: "IN_PROGRESS",
  TERMINATED: "TERMINATED",
  TERMINATING: "TERMINATING",
  CANCELLED: "CANCELLED",
};

export const PROCESS_STATUS_NAME = {
  SUBMITTED: "SUBMITTED",
  PENDING: "PENDING",
  RUNNABLE: "RUNNABLE",
  STARTING: "STARTING",
  RUNNING: "RUNNING",
  SUCCEEDED: "SUCCEEDED",
  FAILED: "FAILED",
  SUCCESSFUL: "SUCCESSFUL",
  IN_PROGRESS: "IN PROGRESS",
  TERMINATED: "TERMINATED",
  TERMINATING: "TERMINATING",
};

export const ALLOW_EDIT_STATUS = [PROCESS_STATUS.SUCCEEDED, PROCESS_STATUS.FAILED, PROCESS_STATUS.PENDING];

export const alertDefault = {
  status: false,
  message: "",
  type: "success",
};

export const UPLOAD_FAIL_TYPE = {
  LIMIT: "limit",
};

export const TOAST_DISPLAY_TIME = 15000;
export const REFETCH_INTERVAL_TIME = 15000;
export const RETRY_TIME = 10;

export const FILE_TYPE = {
  JSON: "json",
  CSV: "csv",
  XLSX: "xlsx",
  XLSM: "xlsm",
  KML: "kml",
};

export const GET_LABEL_WITH_STATUS = {
  [PROCESS_STATUS.SUBMITTED]: "primary",
  [PROCESS_STATUS.RUNNING]: "info",
  [PROCESS_STATUS.SUCCEEDED]: "success",
  [PROCESS_STATUS.SUCCESSFUL]: "success",
  [PROCESS_STATUS.FAILED]: "danger",
  [PROCESS_STATUS.IN_PROGRESS]: "info",
  [PROCESS_STATUS.TERMINATING]: "secondary",
  [PROCESS_STATUS.TERMINATED]: "dark",
};

export const LOADING_STATUS = {
  LOADING: "LOADING",
  AUTHENTICATED: "authenticated",
  UNAUTHENTICATED: "unauthenticated",
};

export const SORT_METHODS = {
  ASC: "ASC",
  DESC: "DESC",
};

export const FORM_TYPE = {
  EDIT: "retry",
  NEW: "new",
  COPY: "copy",
};

export const SIMULATION_RESULT = {
  SINGLE: "main.m",
  MULTI: "multiOptimization.m",
  PAYLOAD: "payloadOptimization.m",
  SIX_DOF: "simulateFlightTrajectory6DoF.m",
  MCS: "monteCarloSimulation.m",
  PAYLOAD_SOE_ASSIST: "payloadOptimizationSoeAssist.m",
  DEBRIS_IMPACT_ANALYSIS: "debrisImpactAnalysis.m",
};

export const UPLOAD_TYPE = {
  RAW: "raw_data",
  COEFFICIENT: "aerodynamic_coefficients_data",
  "6DOF": "simulation_6dof",
  GNC_6DOF: "simulation_gnc_6dof",
  GNC: "simulation_2d3f",
};

export const DASHBOARD_STATUS = {
  SUCCEEDED: "successful",
  INPROGRESS: "in_progress",
  FAILED: "failed",
  FIXED: "fixed",
};

export const STATUS_ERROR_CODE = {
  NOT_AUTHORIZED: 401,
  FORBIDDEN: 403,
};

export const PATTERN_NUMBER = /^\s*-?\d+(\.\d*)?([eE][-+]?\d+)?\s*$/;

export const PATTERN_NEGATIVE_NUMBER = /^\s*-?(\d+(\.\d*)?|\.\d+)([eE][-+]?\d+)?\s*$/;
export const PATTERN_INTEGER_NEGATIVE_NUMBER = /^\s*(-?\d+)\s*$/;

export const PATTERN_GRAVITY_OF_CENTER = /^\s*-?\d+(\.\d+)?\s*,\s*-?\d+(\.\d+)?\s*,\s*-?\d+(\.\d+)?\s*$/;
export const PATTERN_NUMERIC_ARRAY_6DOF = /^\s*-?\d+(\.\d+)?\s*,\s*-?\d+(\.\d+)?\s*,\s*-?\d+(\.\d+)?(\s*,\s*-?\d+(\.\d+)?)*\s*$/;
export const PATTERN_NON_ZERO_NUMBER = /^\s*-?(0\.\d*[1-9]\d*|[1-9]\d*(\.\d+)?)([eE][-+]?\d+)?\s*$/;

export const PATTERN_EMAIL = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
export const PATTERN_URL = /^https:\/\/([\w-]+(\.[\w-]+)+)(\/[\w-]*)*\/?(\?.*)?(#.*)?$/;

export const PATTERN_SIMULATION_VERSION = /(\d{4})(\d{2})(\d{2})_(\d+)/;

export const MODE_FLAG = {
  ASC: 0,
  DESC: 1,
};

export const SIMULATION_TYPE = {
  "3DOF": "3DoF",
  "6DOF": "6DoF",
  "6DOF_MCS": "6DoF_MCS",
  GNC_6DOF: "GNC_6DoF",
  "2D3F": "2D3F",
  GNC_6DoF_MCS: "GNC_6DoF_MCS",
};

export const EXECUTION_FILE_TYPE = {
  MAIN: "calculateMassShape.m",
  MAIN_6DOF: "simulateFlightTrajectory6DoF.m",
  EXPECTED_CASUALTY_6DOF: "expectedCasualtyAnalysis.m",
  DEBRIS_IMPACT: "debrisImpactAnalysis.m",
  DISPERSION_6DOF: "dispersionAnalysis6DoF.m",
  MCS_6DOF: "monteCarloSimulation6DoF.m",
};

export const ERROR_CODE_BY_TYPE = {
  json_syntax_error: "FE-0001",
  model_type: "FE-0002",
  missing: "FE-0004",
  "type_error.float": "FE-0005",
  "type_error.int": "FE-0005",
  "type_error.string": "FE-0005",
  string_type: "FE-0005",
  int_parsing: "FE-0005",
  float_parsing: "FE-0005",
  float_type: "FE-0005",
  int_type: "FE-0005",
  "type_error.list": "FE-0005",
  list_type: "FE-0005",
  literal_error: "FE-0006",
  required_ranges: "FE-0006",
  check_positive: "FE-0006",
  check_non_negative: "FE-0006",
  match_length: "FE-0006",
  match: "FE-0007",
  FE_0007: "FE-0007",
  too_short: "FE-0008",
  string_too_short: "FE-0004",
  too_long: "FE-0008",
  empty_data: "FE-0010",
  csv_syntax_error: "FE-0010",
  redundant_column: "FE-0011",
  missing_column: "FE-0011",
  order_mixup: "FE-0011",
  data_empty: "FE-0010",
  SJ_0001: "SJ-0001",
  SJ_0002: "SJ-0002",
  SJ_0003: "FE-0006",
  SJ_0004: "FE-0006",
  SE_0500: "SE-0500",
  SE_0501: "SE-0501",
};

export const SUB_TEXT_BY_ERROR_TYPE = {
  redundant_column: "redundant column",
  missing_column: "missing column",
  order_mixup: "incorrect column",
};

export const MULTI_DASHBOARD_TYPE = {
  MULTI: "multi",
  OPT: "opt",
  FRAGMENT: "fragment",
  DEBRIS_IMPACT: "debris_impact",
}

export const DASHBOARD_TYPE = {
  MAIN: "main",
  SENSITIVITY: "sensitivity",
  ASCENT_6DOF: "dashboard_type_6dof_ascent",
  DESCENT_6DOF: "dashboard_type_6dof_descent",
  GNC_MULTIPLE: "dashboard_type_2d3f",
  GNC_SINGLE: "dashboard_type_2d3f",
  GNC_6DOF: "dashboard_type_gnc_6dof",
  DISPERSION_ERROR: "dashboard_type_3dof_error_metrics",
  DISPERSION_RSS: "dashboard_type_3dof_rss_metrics",
  DISPERSION_ERROR_6DOF: "dashboard_type_6dof_error_metrics",
  DISPERSION_RSS_6DOF: "dashboard_type_6dof_rss_metrics",
  MCS_STATISTICAL: "dashboard_type_3dof_mcs_statistical",
  MCS_TRIMMING: "dashboard_type_3dof_mcs_trimming",
  MCS_6DOF_STATISTICAL: "dashboard_type_6dof_mcs_statistical",
  MCS_6DOF_TRIMMING: "dashboard_type_6dof_mcs_trimming",
  GNC_6DOF_MCS: "dashboard_type_gnc_6dof_mcs",
  FRAGMENT_ANALYSIS: "dashboard_type_3dof_dia",
  DEBRIS_IMPACT: "dashboard_type_3dof_debris_impact",
  EXPECTED_CASUALTY_FAILURE_IMPACT_6DOF: "dashboard_type_6dof_ec_failure_impact",
  EXPECTED_CASUALTY_SUMMARY_6DOF: "dashboard_type_6dof_ec_summary",
};
export const DASHBOARD_STATUS_BY_TYPE = {
  [DASHBOARD_TYPE.MAIN]: "dashboard_status",
  [DASHBOARD_TYPE.SENSITIVITY]: "sensitivity_analysis_dashboard_status",
  [DASHBOARD_TYPE.DISPERSION_ERROR]: "dashboard_status",
  [DASHBOARD_TYPE.DISPERSION_RSS]: "dashboard_status",
  [DASHBOARD_TYPE.DISPERSION_ERROR_6DOF]: "dashboard_status",
  [DASHBOARD_TYPE.DISPERSION_RSS_6DOF]: "dashboard_status",
  [DASHBOARD_TYPE.MCS_TRIMMING]: "dashboard_status",
  [DASHBOARD_TYPE.MCS_STATISTICAL]: "dashboard_status",
  [DASHBOARD_TYPE.MCS_6DOF_TRIMMING]: "dashboard_status",
  [DASHBOARD_TYPE.MCS_6DOF_STATISTICAL]: "dashboard_status",
  [DASHBOARD_TYPE.FRAGMENT_ANALYSIS]: "dashboard_status",
  [DASHBOARD_TYPE.DEBRIS_IMPACT]: "dashboard_status",
  [DASHBOARD_TYPE.EXPECTED_CASUALTY_FAILURE_IMPACT_6DOF]: "dashboard_status",
  [DASHBOARD_TYPE.EXPECTED_CASUALTY_SUMMARY_6DOF]: "dashboard_status",
  [MULTI_DASHBOARD_TYPE.MULTI]: "multi_dashboard_status",
  [MULTI_DASHBOARD_TYPE.OPT]: "opt_dashboard_status",
};
export const DASHBOARD_URL_BY_TYPE = {
  [DASHBOARD_TYPE.MAIN]: "dashboard_url",
  [DASHBOARD_TYPE.SENSITIVITY]: "sensitivity_analysis_dashboard_url",
  [DASHBOARD_TYPE.DISPERSION_ERROR]: "dashboard_url",
  [DASHBOARD_TYPE.DISPERSION_RSS]: "dashboard_url",
  [DASHBOARD_TYPE.DISPERSION_ERROR_6DOF]: "dashboard_url",
  [DASHBOARD_TYPE.DISPERSION_RSS_6DOF]: "dashboard_url",
  [DASHBOARD_TYPE.MCS_TRIMMING]: "dashboard_url",
  [DASHBOARD_TYPE.MCS_STATISTICAL]: "dashboard_url",
  [DASHBOARD_TYPE.MCS_6DOF_TRIMMING]: "dashboard_url",
  [DASHBOARD_TYPE.MCS_6DOF_STATISTICAL]: "dashboard_url",
  [DASHBOARD_TYPE.FRAGMENT_ANALYSIS]: "dashboard_url",
  [DASHBOARD_TYPE.DEBRIS_IMPACT]: "dashboard_url",
  [DASHBOARD_TYPE.EXPECTED_CASUALTY_FAILURE_IMPACT_6DOF]: "dashboard_url",
  [DASHBOARD_TYPE.EXPECTED_CASUALTY_SUMMARY_6DOF]: "dashboard_url",
  [MULTI_DASHBOARD_TYPE.MULTI]: "multi_dashboard_url",
  [MULTI_DASHBOARD_TYPE.OPT]: "opt_dashboard_url",
};
export const DASHBOARD_INPUT_TYPE = {
  MULTIPLE: "multiple",
  SINGLE: "single",
};

export const REFRESH_TIME = 15;

export const MAX_HEIGHT_DISPLAY = 65;

export const HISTORIES_ACTION_NAME = {
  CREATE_ROCKET_MODEL: "create_rocket_model",
  DELETE_ROCKET_MODEL: "delete_rocket_model",
  UPDATE_ROCKET_MODEL: "update_rocket_model",
  ADD_NEW_CALCULATION: "add_new_calculation",
  UPDATE_ENGINE_COMPONENT: "update_engine_component",
  UPDATE_COMPONENT_DETAIL: "update_component_detail",
  RUN_SIMULATION: "run_simulation",
  CALCULATE_THRUST: "calculate_thrust",
  SAVE_UNPROCESSED_COMPONENT_DETAILS: "save_unprocessed_component_details",
};

export const MAPPING_HISTORIES_ACTION_TO_TEXT = (t) => ({
  [HISTORIES_ACTION_NAME.CREATE_ROCKET_MODEL]: t("logs.created"),
  [HISTORIES_ACTION_NAME.UPDATE_ROCKET_MODEL]: t("logs.updated"),
  [HISTORIES_ACTION_NAME.ADD_NEW_CALCULATION]: t("logs.updated"),
  [HISTORIES_ACTION_NAME.UPDATE_ENGINE_COMPONENT]: t("logs.updated"),
  [HISTORIES_ACTION_NAME.UPDATE_COMPONENT_DETAIL]: t("logs.updated"),
  [HISTORIES_ACTION_NAME.RUN_SIMULATION]: t("logs.updated"),
  [HISTORIES_ACTION_NAME.CALCULATE_THRUST]: t("logs.updated"),
  [HISTORIES_ACTION_NAME.SAVE_UNPROCESSED_COMPONENT_DETAILS]: t("logs.updated"),
  [HISTORIES_ACTION_NAME.DELETE_ROCKET_MODEL]: t("logs.deleted"),
});

export const INIT_ROCKET_COMPONENT_DETAIL_COLUMNS = {
  mass: 0,
  l_axis_position: 0,
  length: 0,
  center_of_gravity_x: 0,
  center_of_gravity_y: 0,
  center_of_gravity_z: 0,
  outer_diameter: 0,
  inner_diameter: 0,
  moment_of_inertia_x: 0,
  moment_of_inertia_y: 0,
  moment_of_inertia_z: 0,
  product_of_inertia_x: 0,
  product_of_inertia_y: 0,
  product_of_inertia_z: 0,
};

export const ROCKET_COMPONENT_LEVEL0 = [
  { value: "Fairing", label: "Fairing" },
  { value: "Payload", label: "Payload" },
  { value: "1st Stage Inert", label: "1st Stage Inert" },
  { value: "1st Stage Propellant", label: "1st Stage Propellant" },
  { value: "2nd Stage Inert", label: "2nd Stage Inert" },
  { value: "2nd Stage Propellant", label: "2nd Stage Propellant" },
  { value: "3rd Stage Inert", label: "3rd Stage Inert" },
  { value: "3rd Stage Propellant", label: "3rd Stage Propellant" },
];

export const STAGE = {
  ONE: 1,
  TWO: 2,
  THREE: 3,
};

export const ROCKET_COMPONENTS = {
  [STAGE.ONE]: {
    [STAGE.ONE]: [
      { value: "Fairing", label: "Fairing" },
      { value: "Payload", label: "Payload" },
      { value: "1st Stage Inert", label: "1st Stage Inert" },
      { value: "1st Stage Propellant", label: "1st Stage Propellant" },
    ],
  },
  [STAGE.TWO]: {
    [STAGE.ONE]: [
      { value: "1st Stage Inert", label: "1st Stage Inert" },
      { value: "1st Stage Propellant", label: "1st Stage Propellant" },
    ],
    [STAGE.TWO]: [
      { value: "Fairing", label: "Fairing" },
      { value: "Payload", label: "Payload" },
      { value: "2nd Stage Inert", label: "2nd Stage Inert" },
      { value: "2nd Stage Propellant", label: "2nd Stage Propellant" },
    ],
  },
  [STAGE.THREE]: {
    [STAGE.ONE]: [
      { value: "1st Stage Inert", label: "1st Stage Inert" },
      { value: "1st Stage Propellant", label: "1st Stage Propellant" },
    ],
    [STAGE.TWO]: [
      { value: "2nd Stage Inert", label: "2nd Stage Inert" },
      { value: "2nd Stage Propellant", label: "2nd Stage Propellant" },
    ],
    [STAGE.THREE]: [
      { value: "Fairing", label: "Fairing" },
      { value: "Payload", label: "Payload" },
      { value: "3rd Stage Inert", label: "3rd Stage Inert" },
      { value: "3rd Stage Propellant", label: "3rd Stage Propellant" },
    ],
  },
};

export const getOrdinalNumber = (count) => {
  if (count === 1) return "st";
  if (count === 2) return "nd";
  if (count === 3) return "rd";

  return "th";
};

export const INIT_ROCKET_COMPONENT_DETAIL_ITEM = (stageCount) =>
  Array.from({ length: stageCount }, (_, i) => ({
    name: `${stageCount - i}`,
    type: `stage`,
    children: [
      {
        name: `${stageCount - i}${getOrdinalNumber(stageCount - i)} Stage Inert`,
        type: "level",
        original_stage: stageCount - i,
        children: [
          {
            name: `Level ${stageCount - i} name`,
            type: "level",
            children: [
              {
                name: "Component name",
                type: "component",
                properties: {
                  ...PROPERTIES_TEMPLATE,
                },
              },
            ],
          },
        ],
      },
    ],
  }));

export const PROPERTIES_TEMPLATE = {
  mass: {
    unit: "kg",
    value: 0,
  },
  length: {
    unit: "m",
    value: 0,
  },
  inner_diameter: {
    unit: "m",
    value: 0,
  },
  outer_diameter: {
    unit: "m",
    value: 0,
  },
  l_axis_position: 0,
  center_of_gravity: {
    unit: "m",
    value: [0, 0, 0],
  },
  moment_of_inertia: {
    unit: "kgm^2",
    value: [0, 0, 0],
  },
  product_of_inertia: {
    unit: "kgm^2",
    value: [0, 0, 0],
  },
};

export const MODEL_DETAIL_TEMPLATE_CSV = {
  1: `,mass (kg),length (m),center_of_gravity_gx (m),center_of_gravity_gy (m),center_of_gravity_gz (m),diameter (m),tensor_of_inertia (kgm^2)
gross,0.0,0.0,0.0,0.0,0.0,0.0,"[[0.0,0.0,0.0][0.0,0.0,0.0][0.0,0.0,0.0]]"
dry,0.0,0.0,0.0,0.0,0.0,0.0,"[[0.0,0.0,0.0][0.0,0.0,0.0][0.0,0.0,0.0]]"
dry_without_fairing,0.0,0.0,0.0,0.0,0.0,0.0,"[[0.0,0.0,0.0][0.0,0.0,0.0][0.0,0.0,0.0]]"
stage1,0.0,0.0,0.0,0.0,0.0,0.0,"[[0.0,0.0,0.0][0.0,0.0,0.0][0.0,0.0,0.0]]"
stage1_without_fairing,0.0,0.0,0.0,0.0,0.0,0.0,"[[0.0,0.0,0.0][0.0,0.0,0.0][0.0,0.0,0.0]]"
stage1_without_fairing_payload,0.0,0.0,0.0,0.0,0.0,0.0,"[[0.0,0.0,0.0][0.0,0.0,0.0][0.0,0.0,0.0]]"`,
  2: `,mass (kg),length (m),center_of_gravity_gx (m),center_of_gravity_gy (m),center_of_gravity_gz (m),diameter (m),tensor_of_inertia (kgm^2)
gross,0.0,0.0,0.0,0.0,0.0,0.0,"[[0.0,0.0,0.0][0.0,0.0,0.0][0.0,0.0,0.0]]"
dry,0.0,0.0,0.0,0.0,0.0,0.0,"[[0.0,0.0,0.0][0.0,0.0,0.0][0.0,0.0,0.0]]"
dry_without_fairing,0.0,0.0,0.0,0.0,0.0,0.0,"[[0.0,0.0,0.0][0.0,0.0,0.0][0.0,0.0,0.0]]"
stage1,0.0,0.0,0.0,0.0,0.0,0.0,"[[0.0,0.0,0.0][0.0,0.0,0.0][0.0,0.0,0.0]]"
stage2,0.0,0.0,0.0,0.0,0.0,0.0,"[[0.0,0.0,0.0][0.0,0.0,0.0][0.0,0.0,0.0]]"
stage2_without_fairing,0.0,0.0,0.0,0.0,0.0,0.0,"[[0.0,0.0,0.0][0.0,0.0,0.0][0.0,0.0,0.0]]"
stage2_without_fairing_payload,0.0,0.0,0.0,0.0,0.0,0.0,"[[0.0,0.0,0.0][0.0,0.0,0.0][0.0,0.0,0.0]]"`,
  3: `,mass (kg),length (m),center_of_gravity_gx (m),center_of_gravity_gy (m),center_of_gravity_gz (m),diameter (m),tensor_of_inertia (kgm^2)
gross,0.0,0.0,0.0,0.0,0.0,0.0,"[[0.0,0.0,0.0][0.0,0.0,0.0][0.0,0.0,0.0]]"
dry,0.0,0.0,0.0,0.0,0.0,0.0,"[[0.0,0.0,0.0][0.0,0.0,0.0][0.0,0.0,0.0]]"
dry_without_fairing,0.0,0.0,0.0,0.0,0.0,0.0,"[[0.0,0.0,0.0][0.0,0.0,0.0][0.0,0.0,0.0]]"
stage1,0.0,0.0,0.0,0.0,0.0,0.0,"[[0.0,0.0,0.0][0.0,0.0,0.0][0.0,0.0,0.0]]"
stage2,0.0,0.0,0.0,0.0,0.0,0.0,"[[0.0,0.0,0.0][0.0,0.0,0.0][0.0,0.0,0.0]]"
stage3,0.0,0.0,0.0,0.0,0.0,0.0,"[[0.0,0.0,0.0][0.0,0.0,0.0][0.0,0.0,0.0]]"
stage3_without_fairing,0.0,0.0,0.0,0.0,0.0,0.0,"[[0.0,0.0,0.0][0.0,0.0,0.0][0.0,0.0,0.0]]"
stage3_without_fairing_payload,0.0,0.0,0.0,0.0,0.0,0.0,"[[0.0,0.0,0.0][0.0,0.0,0.0][0.0,0.0,0.0]]"`,
};

export const STAGE_OPTIONS = [
  { label: "1", value: 1 },
  { label: "2", value: 2 },
  { label: "3", value: 3 },
];

export const STAGE_MODES_OPTIONS = [
  { label: "Ascent", value: "ascent" },
  { label: "Descent", value: "descent" },
];

export const ACTION_NAME = {
  RUN_SIMULATION: "run_batch_calculation",
};

export const PROGRESS_STATUS = {
  FIXED: "fixed",
  IN_PROGRESS: "in_progress",
};

export const CHART_CONTAINER_WIDTH = {
  SM: 300,
  MD: 600,
};

export const CHART_LIMIT_TICKS = {
  SMALL: 5,
  MEDIUM: 10,
  BIG: 10,
};

export const SIMULATION_TYPE_OPTIONS = {
  "3DOF": SIMULATION_TYPE["3DOF"],
  "6DOF": SIMULATION_TYPE["6DOF"],
};

export const CONFIG_FIELD_ORDER = [
  "representative_surface_areas",
  "representative_length",
  "mach_classification_unit",
  "test_airflow_settling",
  "base_area",
  "cavity_area",
  "angle_of_attack_classification_unit",
  "min_angle_of_attack",
  "max_angle_of_attack",
  "error_range_of_angle_of_attack",
];

export const VALIDATE_RULE_BY_FIELD = (t) => ({
  min_angle_of_attack: {
    max: {
      field: "max_angle_of_attack",
      msg: t("new.aoa_min_validate"),
    },
    customClass: "col-4 d-inline-block pl-1 m-b-35",
    allowNegative: true,
    unit: "deg",
  },
  max_angle_of_attack: {
    min: {
      field: "min_angle_of_attack",
      msg: t("new.aoa_max_validate"),
    },
    customClass: "col-4 d-inline-block px-1 m-b-35",
    allowNegative: true,
    notShowLabel: true,
  },
  error_range_of_angle_of_attack: {
    customClass: "col-4 d-inline-block pr-1 m-b-35",
    notShowLabel: true,
  },
  test_airflow_settling: {
    allowNegative: true,
    unit: "s",
  },
  angle_of_attack_classification_unit: {
    unit: "deg",
  },
  representative_surface_areas: {
    unit: "m\u00B2",
  },
  representative_length: {
    unit: "m",
  },
  base_area: {
    unit: "m\u00B2",
  },
  cavity_area: {
    unit: "m\u00B2",
  },
});

export const INPUT_DATA_GNC_6DOF_MAPPING = [
  { key: "initial_condition.initial_position", field: "initial_position", text: "Initial Position" },
  { key: "initial_condition.initial_velocity", field: "initial_velocity", text: "Initial Velocity" },
  { key: "initial_condition.initial_euler", field: "initial_euler", text: "Initial Attitude Angle" },
  { key: "initial_condition.initial_angular_velocity", field: "initial_angular_velocity", text: "Initial Angular Velocity" },
  { key: "vehicle.dry_mass", field: "dry_mass", text: "Dry Mass" },
  { key: "vehicle.propellant_mass", field: "propellant_mass", text: "Propellant Mass" },
  { key: "vehicle.non_propellant_mass", field: "non_propellant_mass", text: "Non Propellant Mass" },
  { key: "vehicle.engine_mass", field: "engine_mass", text: "Engine Mass" },
  { key: "environment.wind_speed", field: "wind_speed", text: "Wind Speed" },
  { key: "environment.wind_direction", field: "wind_direction", text: "Wind Direction" },
];

export const TERMINAL_GNC_6DOF_MAPPING = [
  { field: "Altitude[m]", text: "Altitude[m]" },
  { field: "East[m]", text: "East[m]" },
  { field: "North[m]", text: "North[m]" },
  { field: "u[m/s]", text: "u[m/s]" },
  { field: "v[m/s]", text: "v[m/s]" },
  { field: "w[m/s]", text: "w[m/s]" },
  { field: "Roll[deg]", text: "Roll[deg]" },
  { field: "Pitch[deg]", text: "Pitch[deg]" },
  { field: "Yaw[deg]", text: "Yaw[deg]" },
  { field: "P[deg/s]", text: "P[deg/s]" },
  { field: "Q[deg/s]", text: "Q[deg/s]" },
  { field: "R[deg/s]", text: "R[deg/s]" },
  { field: "Fuel[kg]", text: "Fuel[kg]" },
];

export const FORM_NAME = {
  NAME: "name",
  VERSION: "version_name",
  NOTE: "note",
  TYPE: "type",
  SERIES: "series",
  AERODYNAMIC_COEFFICIENTS_PATH: "aerodynamic_coefficients_path",
  PARAMETER_PATH: "parameter_path",
  MAIN: {
    SIMULATION_TIME: "simulation_time",
  },
  VEHICLE: {
    LENGTH: "vehicle_length",
    DRY_MASS: "dry_mass",
    RADIUS: "vehicle_radius",
    ENGINE_MASS: "engine_mass",
    PROPELLANT_MASS: "propellant_mass",
    NON_PROPELLANT_MASS: "non_propellant_mass",
    CENTER_OF_GRAVITY_TOTAL_MASS: "center_of_gravity_total_mass",
    CENTER_OF_GRAVITY_DRY_MASS: "center_of_gravity_dry_mass",
    CENTER_OF_GRAVITY_TANK: "center_of_gravity_tank",
    CENTER_OF_PRESSURE: "center_of_pressure",
    MOMENT_OF_INERTIA_TOTAL_MASS: "inertia_total_mass",
    MOMENT_OF_INERTIA_DRY_MASS: "inertia_dry_mass",
    GIMBAL_TO_THRUST_DISTANCE: "gimbal_to_thrust_distance",
  },
  ENVIRONMENT: {
    WIND_SPEED: "wind_speed",
    WIND_DIRECTION: "wind_direction",
    AIR_DENSITY: "air_density",
    GRAVITY: "gravity",
    ATMOSPHERIC_PRESSURE: "atmospheric_pressure",
  },
  INITIAL_CONDITION: {
    INITIAL_MODEL: "initial_model",
    POSITION: "initial_position",
    VELOCITY: "initial_velocity",
    ATTITUDE_ANGLE: "initial_euler",
    ANGULAR_VELOCITY: "initial_angular_velocity",
    ENGINE_STATE: "initial_engine_state",
    EMERGENCY_STOP_TIME: "emergency_stop_time",
    EMERGENCY_LANDING_TIME: "emergency_landing_time",
  },
  TARGET: {
    ASCENT_POSITION: "ascent_position",
    ASCENT_VELOCITY: "ascent_velocity",
    GEODETIC_LLA0: "geodetic_lla0",
    GEODETIC_LLAF: "geodetic_llaf",
    LANDING_VELOCITY: "landing_velocity",
  },
  MCS: {
    SIMULATION_MODE: "MCS_flag",
    NUMBER_OF_MCS_SIM_RUNS: "number_of_samples",
    POSITION: "sigma_pos0",
    VELOCITY: "sigma_vel0",
    ATTITUDE_ANGLE: "sigma_euler0",
    ANGULAR_VELOCITY: "sigma_omega0",
    DRY_MASS: "sigma_m_dry",
    PROPELLANT_MASS: "sigma_m_propellant",
    CENTER_OF_GRAVITY_TOTAL_MASS: "sigma_CG_s",
    CENTER_OF_GRAVITY_DRY_MASS: "sigma_CG_e",
    MOMENT_OF_INERTIA_TOTAL_MASS: "sigma_I_s",
    MOMENT_OF_INERTIA_TOTAL_MASS_X: "sigma_I_s_x",
    MOMENT_OF_INERTIA_TOTAL_MASS_Y: "sigma_I_s_y",
    MOMENT_OF_INERTIA_TOTAL_MASS_Z: "sigma_I_s_z",
    MOMENT_OF_INERTIA_DRY_MASS: "sigma_I_e",
    MOMENT_OF_INERTIA_DRY_MASS_X: "sigma_I_e_x",
    MOMENT_OF_INERTIA_DRY_MASS_Y: "sigma_I_e_y",
    MOMENT_OF_INERTIA_DRY_MASS_Z: "sigma_I_e_z",
    CENTER_OF_GRAVITY_TANK: "sigma_CG_tank",
    FUEL_POSITION_TOTAL_MASS: "sigma_pos_fuel_s",
    FUEL_POSITION_DRY_MASS: "sigma_pos_fuel_e",
    CA: "sigma_CA_data",
    CY: "sigma_CY_data",
    CN: "sigma_CN_data",
    Cl: "sigma_Cl_data",
    Cm: "sigma_Cm_data",
    Cn: "sigma_Cn_data",
    VACUUM_ISP: "sigma_Isp",
    MAX_THRUST_OF_ENGINE: "sigma_thrust_max",
    THRUST_TIME_CONSTANT: "sigma_thrust_tau",
    THRUST_DELAY_TIME: "sigma_thrust_DT",
    ENGINE_PITCH_LENGTH: "sigma_L_engine_pitch",
    TVC1_POSITION: "sigma_TVC1_pos",
    TVC2_POSITION: "sigma_TVC2_pos",
    TVC_ACTUATOR_NATURAL_FREQUENCY: "sigma_omega_c",
    DAMPING_RATIO: "sigma_zeta",
    TVC_ACTUATOR_FREQUENCY: "sigma_omega_T",
    MAXIMUM_TVC_DEFLECTION: "sigma_TVC_max",
    MINIMUM_TVC_DEFLECTION: "sigma_TVC_min",
    MAXIMUM_TVC_DEFLECTION_LIMIT: "sigma_TVC_rateLim",
    RCS_SPECIFIC_IMPULSE: "sigma_Isp_RCS",
    FUEL_MASS_RCS: "sigma_m_RCS",
    THRUST_OF_RCS_THRUSTER: "sigma_Fc",
    TIME_CONSTANT_OF_RCS_SYSTEM: "sigma_tau_RCS",
    DEAD_TIME_OF_RCS_SYSTEM: "sigma_DT_RCS",
    WIND_SPEED_AT_INITIAL_ALTITUDE: "sigma_wind_speed",
    WIND_DIRECTION_AT_INITIAL_ALTITUDE: "sigma_wind_direction",
    MAXIMUM_ACCELERATION: "sigma_max_acc",
    ACCELEROMETER_LSB_RESOLUTION: "sigma_LSB_acc",
    VELOCITY_RANDOM_WALK: "sigma_RW_acc",
    ACCELEROMETER_BIAS: "sigma_BU_acc",
    TEMPERATURE_BIAS_OF_ACCELEROMETER: "sigma_TB_acc",
    MAX_GYRO: "sigma_max_gyro",
    GYROSCOPE_LSB_RESOLUTION: "sigma_LSB_gyro",
    ANGLE_RANDOM_WALK: "sigma_RW_gyro",
    GYRO_BIAS: "sigma_BU_gyro",
    TEMPERATURE_BIAS_OF_GYRO: "sigma_TB_gyro",
    SKEW_OF_SENSOR_AXES: "sigma_skew",
    HORIZONTAL_POSITION_ACCURACY: "sigma_pos_err1",
    VERTICAL_POSITION_ACCURACY: "sigma_pos_err2",
    VELOCITY_ACCURACY: "sigma_vel_err",
    ALTITUDE_REFERENCE: "altitude_reference",
    EAST_WEST_POSITION_REFERENCE: "east_reference",
    NORTH_SOUTH_POSITION_REFERENCE: "north_reference",
    VERTICAL_VELOCITY_REFERENCE: "vel_x_reference",
    EAST_WEST_VELOCITY_REFERENCE: "vel_y_reference",
    NORTH_SOUTH_VELOCITY_REFERENCE: "vel_z_reference",
    ROLL_ANGLE: "roll_reference",
    PITCH_ANGLE: "pitch_reference",
    YAW_ANGLE: "yaw_reference",
    ROLL_RATE: "roll_rate_reference",
    PITCH_RATE: "pitch_rate_reference",
    YAW_RATE: "yaw_rate_reference",
  },
};

export const SIMULATION_MODES = {
  SIM: "SIM",
  MCS: "MCS",
};
export const RESOURCE_TYPE = {
  FLIGHT_SIMULATION: "flight_simulation",
  TEST_ANALYSIS: "test_analysis",
  GNC_SIMULATION: "gnc_simulation",
  LABOR_SAVING: "labor_saving",
};

export const ROUTER_BY_RESOURCE = {
  [RESOURCE_TYPE.TEST_ANALYSIS]: APP_ROUTES.TEST_ANALYSIS_LIST,
  [RESOURCE_TYPE.FLIGHT_SIMULATION]: APP_ROUTES.HOME,
  [RESOURCE_TYPE.GNC_SIMULATION]: APP_ROUTES.GNC_SIMULATOR,
  [RESOURCE_TYPE.LABOR_SAVING]: APP_ROUTES.ROCKET_MODEL,
};

export const ROLES = {
  SERVICE_ADMIN: "service_admin",
  ADMIN: "admin",
  VIEWER: "viewer",
  EDITOR: "editor",
};

export const SERVER_STATUS = {
  RUNNING: "running",
  DOWN: "down",
  STOP: "stopping",
};

export const TARGET_MODE = {
  RATE: 1,
  ATTITUDE: 0,
};

export const WORKFLOW_SIMULATION_TYPE = {
  [SIMULATION_TYPE["3DOF"]]: "flight_3dof",
  [SIMULATION_TYPE["6DOF"]]: "flight_6dof",
};

export const AUTOMATION_STATUS_CLASSNAME = {
  [PROCESS_STATUS.RUNNING]: "text-info",
  [PROCESS_STATUS.SUCCEEDED]: "text-success",
  [PROCESS_STATUS.FAILED]: "text-danger",
  [PROCESS_STATUS.CANCELLED]: "text-warning",
};

export const VERSION_TYPE = {
  PROD: "production",
  DEV: "development",
}

export const RESOURCE_TYPE_FOR_TAG = {
  ROCKET_MODEL: "rocket_model",
  ENGINE_COMPONENT: "engine_component",
  THRUST_CALCULATOR: "thrust_calculator",
  FLIGHT_SIMULATOR: "flight_simulator",
  WIND_TUNNEL_TEST_ISAS: "wind_tunnel_test_isas",
  WIND_TUNNEL_TEST_NAL: "wind_tunnel_test_nal",
  GNC_SIMULATOR: "gnc_simulator",
  GNC_6DOF_SIMULATOR: "gnc_6dof_simulator",
};
